import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { EdmundsUniverse } from 'site-modules/shared/components/edmunds-universe/edmunds-universe';

import './glossary-content.scss';

export function GlossaryContent({ breadcrumbsData, title, introductionContent = null, termsContent }) {
  return (
    <Container tag="main" id="main-content" tabIndex={-1} className="glossary-content">
      <Breadcrumbs data={breadcrumbsData} className="ps-0" />
      <h1 className="heading-2 mb-1_5">{title}</h1>
      <Row>
        <Col xs={12} lg={8} className="mb-1_5">
          {!!introductionContent && (
            <Fragment>
              <ContentFragment classes="text-gray-darker">{introductionContent}</ContentFragment>
              <hr className="mt-1_5 mb-2" />
            </Fragment>
          )}
          <ContentFragment classes="text-gray-darker">{termsContent}</ContentFragment>
        </Col>
        <Col xs={12} lg={4} className="mb-1_5 mb-lg-0">
          <EdmundsUniverse />
        </Col>
      </Row>
    </Container>
  );
}

GlossaryContent.propTypes = {
  breadcrumbsData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
  termsContent: PropTypes.string.isRequired,
  introductionContent: PropTypes.string,
};
